import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/bluecoins/')({
  beforeLoad: () => ({
    documentTitle: { main: 'table_list.tabs.bluecoin.list', suffix: 'menu.bluecoins' },
  }),
  // Index route - the list is rendered by the parent layout
  // This route exists just to match /bluecoins/ (with trailing slash)
  component: () => null,
});
